type ItemWithName = {
  /** The name of the item. */
  name?: string;
};

/**
 * @param itemA The first item to sort.
 * @param itemB The second item to sort.
 * @returns A number indicating the order that the items should be sorted in.
 */
export function sortByName(itemA: ItemWithName, itemB: ItemWithName): number {
  const nameA = itemA.name;
  const nameB = itemB.name;
  if (nameA === undefined || nameB === undefined) return 0;

  return nameA.localeCompare(nameB, undefined, { sensitivity: "base" });
}
